import api from "@/lib/api";

const SOURCE_KEY = "de_source";

/**
 * Source du lead : UTM si présents, sinon referrer externe, sinon "direct".
 * Mémorisée en sessionStorage pour suivre toute la session de navigation.
 */
export function getSource() {
  try {
    const saved = sessionStorage.getItem(SOURCE_KEY);
    if (saved) return saved;
    const params = new URLSearchParams(window.location.search);
    const utm = params.get("utm_source");
    let source;
    if (utm) {
      source = [utm, params.get("utm_medium"), params.get("utm_campaign")].filter(Boolean).join(" / ");
    } else if (document.referrer && !document.referrer.includes(window.location.host)) {
      try { source = new URL(document.referrer).hostname; } catch { source = "direct"; }
    } else {
      source = "direct";
    }
    sessionStorage.setItem(SOURCE_KEY, source);
    return source;
  } catch {
    return "direct";
  }
}

/** Enregistre un événement de conversion (click_brief, click_phone, form_step, form_submit…). */
export function track(event, meta = "") {
  try {
    api.post("/track", { event, page: window.location.pathname, source: getSource(), meta }).catch(() => {});
  } catch { /* noop */ }
}
